Ext.define('SA.model.LocationFactory', {
    statics: {
        create(id) {
            this.instance ??= new SA.model.LocationFactory();

            return this.instance.create(id);
        }
    },

    create(id) {
        if (SA.model.CustomLocationStringId.match(id)) {
            return this.create(SA.model.CustomLocationStringId.getInteger(id));
        }
        else if (SA.data.CustomLocations.isRadiusId(id)) {
            return this.createRadius(id);
        }
        else if (SA.data.CustomLocations.isComboId(id)) {
            return this.createCombo(id);
        }

        return this.createSeries(id);
    },

    createCombo(intId) {
        var typeString = 'combo',
            data = SA.data.CustomLocations.get(intId),
            name = data.name,
            stringId = SA.model.CustomLocationStringId.forInteger(intId),
            constituents = data.locationSeries.map(id => this.createSeries(id)),
            constituentIds = constituents.map(constituent => constituent.getId()),
            normalizedValue = SA.model.NormalizedLocationBuilder.forCombo()
                .stringId(stringId)
                .locationSeries(constituentIds)
                .build();

        return new SA.model.ComboLocation({typeString, intId, stringId, name, normalizedValue, constituents});
    },

    createRadius(intId) {
        var typeString = 'radius',
            data = SA.data.CustomLocations.get(intId),
            name = data.name,
            stringId = SA.model.CustomLocationStringId.forInteger(intId),
            centerLocation = this.createSeries(data.locationSeries),
            radiusSizeInMeters = SA.model.RadiusLocationSize.getValueInMeters({value: data.radius, unit: data.unit}),
            normalizedValue = SA.model.NormalizedLocationBuilder.forRadius()
                .stringId(stringId)
                .locationSeries(centerLocation.getId())
                .radiusSizeInMeters(radiusSizeInMeters)
                .build();

        return new SA.model.RadiusLocation({typeString, intId, stringId, name, normalizedValue, centerLocation, radiusSizeInMeters});
    },

    createSeries(id) {
        var typeString = 'series',
            data = SA.data.LocationsCache.get(id),
            name = data.name,
            alias = data.locationAlias,
            censusReleaseYears = data.censusReleases.slice(),
            geoUnitId = data.geographicUnit,
            normalizedValue = SA.model.NormalizedLocationBuilder.forSeries()
                .stringId(id)
                .locationSeries(id)
                .build();

        return new SA.model.SeriesLocation({typeString, id, name, alias, normalizedValue, censusReleaseYears, geoUnitId});
    }
});